module.exports = __webpack_public_path__ + "img/admin3.c95e7c69.png";